import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { GDialog } from 'components/basic-blocks'
import { useStores } from 'hooks'
import PlayButtonIcon from '../../../../../assets/icons/playButton.png'
import { SetupSidebarProps } from './types'
import { useTrackPostHogEvent } from 'utils/posthog'
import { PostHogEvent, PostHogPath } from 'utils/posthog-events'
import { ChatService } from 'services/chat'
import { getOnboardingBookingUrl } from 'utils/hubspot'

const BookOpenIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className="flex-shrink-0"
	>
		<path
			d="M10 5.83333C10 5.83333 8.33333 2.5 4.58333 2.5C2.91667 2.5 1.66667 3.33333 1.66667 3.33333V16.6667C1.66667 16.6667 2.91667 15.8333 4.58333 15.8333C8.33333 15.8333 10 18.3333 10 18.3333M10 5.83333C10 5.83333 11.6667 2.5 15.4167 2.5C17.0833 2.5 18.3333 3.33333 18.3333 3.33333V16.6667C18.3333 16.6667 17.0833 15.8333 15.4167 15.8333C11.6667 15.8333 10 18.3333 10 18.3333M10 5.83333V18.3333"
			style={{ stroke: 'var(--t-email-blue)' }}
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)
const ChatIcon = ({ className }: { className?: string }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="18"
		height="16"
		viewBox="0 0 18 16"
		fill="none"
	>
		<path
			d="M16.3407 7.91732C16.3407 11.8293 13.1694 15.0007 9.25734 15.0007C8.36002 15.0007 7.50168 14.8338 6.71163 14.5294C6.56719 14.4738 6.49496 14.446 6.43753 14.4327C6.38104 14.4197 6.34015 14.4143 6.28222 14.412C6.22332 14.4098 6.15871 14.4165 6.02947 14.4298L1.76195 14.871C1.35509 14.913 1.15165 14.934 1.03165 14.8608C0.927127 14.7971 0.855936 14.6906 0.836985 14.5696C0.815228 14.4308 0.912441 14.2508 1.10687 13.8909L2.46991 11.368C2.58217 11.1602 2.63829 11.0563 2.66372 10.9564C2.68882 10.8578 2.69489 10.7867 2.68686 10.6852C2.67873 10.5824 2.63365 10.4487 2.54348 10.1812C2.30388 9.47031 2.174 8.70898 2.174 7.91732C2.174 4.0053 5.34532 0.833984 9.25734 0.833984C13.1694 0.833984 16.3407 4.0053 16.3407 7.91732Z"
			style={{ stroke: 'var(--icon-email-strong)' }}
			stroke-width="1.66667"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
)

const MessageSquareIcon = () => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className="flex-shrink-0"
	>
		<path
			d="M5.83333 6.66667H10M5.83333 10H13.3333M10 17.5L7.08333 14.1667H4.16667C2.78595 14.1667 1.66667 13.0474 1.66667 11.6667V4.16667C1.66667 2.78595 2.78595 1.66667 4.16667 1.66667H15.8333C17.214 1.66667 18.3333 2.78595 18.3333 4.16667V11.6667C18.3333 13.0474 17.214 14.1667 15.8333 14.1667H12.9167L10 17.5Z"
			style={{ stroke: 'var(--t-email-blue)' }}
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)
const PhoneIcon = ({ className }: { className?: string }) => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className="flex-shrink-0"
	>
		<path
			d="M11.7081 4.99984C12.5221 5.15864 13.2701 5.55672 13.8565 6.14312C14.4429 6.72952 14.841 7.47756 14.9998 8.2915M11.7081 1.6665C13.3992 1.85437 14.9761 2.61165 16.18 3.81401C17.3839 5.01637 18.1431 6.59235 18.3331 8.28317M8.52228 11.5524C7.52097 10.5511 6.73031 9.41888 6.15031 8.21086C6.10042 8.10695 6.07548 8.055 6.05631 7.98926C5.98821 7.75563 6.03713 7.46875 6.17881 7.27089C6.21867 7.21521 6.2663 7.16758 6.36156 7.07232C6.6529 6.78098 6.79857 6.63531 6.89381 6.48883C7.25297 5.93642 7.25297 5.22427 6.89381 4.67186C6.79857 4.52538 6.6529 4.37971 6.36156 4.08837L6.19917 3.92598C5.7563 3.48311 5.53487 3.26168 5.29705 3.14139C4.82408 2.90217 4.26553 2.90217 3.79256 3.14139C3.55474 3.26168 3.33331 3.48311 2.89044 3.92598L2.75908 4.05735C2.31773 4.4987 2.09705 4.71937 1.92851 5.0194C1.74149 5.35232 1.60703 5.8694 1.60816 6.25125C1.60918 6.59537 1.67594 6.83056 1.80944 7.30093C2.52692 9.82876 3.88065 12.2141 5.87063 14.204C7.86061 16.194 10.2459 17.5478 12.7737 18.2652C13.2441 18.3987 13.4793 18.4655 13.8234 18.4665C14.2053 18.4677 14.7224 18.3332 15.0553 18.1462C15.3553 17.9776 15.576 17.7569 16.0173 17.3156L16.1487 17.1842C16.5916 16.7414 16.813 16.5199 16.9333 16.2821C17.1725 15.8091 17.1725 15.2506 16.9333 14.7776C16.813 14.5398 16.5916 14.3184 16.1487 13.8755L15.9863 13.7131C15.695 13.4218 15.5493 13.2761 15.4028 13.1809C14.8504 12.8217 14.1383 12.8217 13.5858 13.1809C13.4394 13.2761 13.2937 13.4218 13.0024 13.7131C12.9071 13.8084 12.8595 13.856 12.8038 13.8959C12.6059 14.0375 12.319 14.0865 12.0854 14.0184C12.0197 13.9992 11.9677 13.9743 11.8638 13.9244C10.6558 13.3444 9.5236 12.5537 8.52228 11.5524Z"
			style={{ stroke: 'var(--icon-primary)' }}
			strokeWidth="1.66667"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

const ShieldIcon = () => (
	<svg
		className="w-5 h-5 flex-shrink-0"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M6.06422 12.4175C6.06422 12.5196 6.1358 12.646 6.22297 12.6987L9.84051 14.88C9.92769 14.9327 10.0708 14.9327 10.158 14.88L13.7756 12.6987C13.8631 12.646 13.9343 12.5196 13.9343 12.4175V11.9086C13.9343 11.8066 13.8509 11.7232 13.7489 11.7232H11.8943C11.7923 11.7232 11.6372 11.7662 11.5497 11.8185L10.1576 12.6545C10.0701 12.7072 9.92729 12.7072 9.83975 12.6545L8.44774 11.8185C8.36019 11.7659 8.2886 11.6397 8.2886 11.5377V7.42095C8.2886 7.31895 8.3691 7.21287 8.46699 7.18503L9.82013 6.80264C9.91839 6.7748 10.079 6.7748 10.1769 6.80264L11.5297 7.18503C11.6279 7.21287 11.7915 7.23547 11.8935 7.23547H13.7481C13.8501 7.23547 13.9336 7.15204 13.9336 7.05003V5.82452C13.9336 5.72252 13.8534 5.61644 13.7551 5.58861L10.1769 4.5775C10.0786 4.54969 9.91803 4.54969 9.82013 4.5775L6.24188 5.58861C6.14359 5.61644 6.06348 5.72252 6.06348 5.82452V12.4175H6.06422Z"
			style={{ fill: 'var(--color-brand)' }}
		/>
		<path
			d="M9.74558 18.9369C9.88541 19.021 10.1139 19.021 10.2537 18.9369L17.2043 14.7455C17.3441 14.6613 17.4584 14.4588 17.4584 14.2956V8.67544C17.4584 8.51224 17.3249 8.37873 17.1616 8.37873H10.2964C10.1332 8.37873 9.99962 8.51224 9.99962 8.67544V10.3075C9.99962 10.4707 10.1332 10.6042 10.2964 10.6042H14.9365C15.0998 10.6042 15.2333 10.7377 15.2333 10.9009V13.0389C15.2333 13.2021 15.119 13.4046 14.9792 13.4888L10.2541 16.3382C10.1142 16.4224 9.88578 16.4224 9.74594 16.3382L5.02047 13.4888C4.88064 13.4046 4.76639 13.2021 4.76639 13.0389V4.95331C4.76639 4.79011 4.89473 4.62023 5.052 4.57572L9.7144 3.2586C9.87131 3.21409 10.1283 3.21409 10.2856 3.2586L14.948 4.57572C15.1049 4.62023 15.2336 4.79011 15.2336 4.95331V6.93845C15.2336 7.10165 15.3672 7.2352 15.5304 7.2352H17.1624C17.3256 7.2352 17.4591 7.10165 17.4591 6.93845V3.35096C17.4591 3.18775 17.3308 3.01787 17.1735 2.97374L10.2853 1.0331C10.1283 0.988965 9.87131 0.988965 9.71403 1.0331L2.82613 2.97374C2.66886 3.01787 2.54053 3.18775 2.54053 3.35096V14.2959C2.54053 14.4591 2.65477 14.6617 2.7946 14.7459L9.74518 18.9372L9.74558 18.9369Z"
			style={{ fill: 'var(--color-brand)' }}
		/>
	</svg>
)

export const SetupSidebar = ({
	step = '1',
	adAccountConnected = false,
	videoThumbnail,
	videoUrl,
	videoTitle,
	knowledgeBaseUrl = 'https://docs.clickguard.com',
	accountId,
	assetId
}: SetupSidebarProps) => {
	const [showVideoDialog, setShowVideoDialog] = useState(false)
	const navigate = useNavigate()
	const { assetStore } = useStores()
	const { allAssets } = assetStore
	// Check if this is the first website (no existing assets for this account)
	const websiteCount = allAssets.filter(
		(a) => a.account_id === accountId
	).length
	const trackPostHogEvent = useTrackPostHogEvent()
	const stepNum = parseInt(step) || 1

	const isFirstWebsite = stepNum === 1 ? websiteCount === 0 : websiteCount === 1

	// Handle skip to dashboard navigation
	const handleSkipToDashboard = () => {
		trackPostHogEvent(
			PostHogEvent.ONBOARDING_SKIP_TO_DASHBOARD,
			PostHogPath.ONBOARDING,
			null
		)
		if (accountId && assetId) {
			navigate(`/workspace/${accountId}/asset/${assetId}`)
		} else if (accountId) {
			const firstAsset = allAssets.find((a) => a.account_id === accountId)
			if (firstAsset) {
				navigate(`/workspace/${accountId}/asset/${firstAsset.id}`)
			} else {
				navigate(`/workspace/${accountId}`)
			}
		}
	}

	// Calculate the blue progress line height based on current step
	// Step 1: Blue goes from top to between step 1 and step 2 (35px)
	// Step 2: Blue goes from top to between step 2 and step 3 (105px = 70px to step 2 center + 35px halfway to step 3)
	// Step 3: Blue goes all the way to the bottom (100%)
	const getProgressHeight = () => {
		if (stepNum === 1) {
			return '35px' // Between step 1 and step 2
		} else if (stepNum === 2) {
			return adAccountConnected ? '100%' : '50%'
		} else {
			return '100%' // Fully blue for step 3
		}
	}

	const progressHeight = getProgressHeight()

	// Determine if steps are completed
	const isStep1Completed = stepNum >= 2
	const isStep2Completed = stepNum >= 3 || (stepNum === 2 && adAccountConnected)
	const isStep2Active = stepNum === 2
	const isStep3Active = stepNum === 3

	return (
		<>
			<div className="lg:w-[220px]">
				{/* Logo and Heading */}
				<div className="text-center lg:text-left">
					<img
						alt="ClickGuard logo"
						className="w-[156px] mx-auto lg:mx-0 mb-[12px] block"
						src="https://storage.googleapis.com/clickguard-storage-dev/public/assets/img/Clickguard%20Logo%20New.svg"
					/>
					<p className="text-t-default text-[19px] leading-[22px] font-medium">
						Complete your setup, achieve{' '}
						<span className="text-t-email-blue">full protection.</span>
					</p>
				</div>
				<div className="h-px w-full bg-[var(--setup-divider,rgba(17,21,83,0.15))] my-[24px] lg:block hidden" />

				{/* Progress Steps */}
				<div className="relative lg:block hidden">
					{/* Progress line container - aligned with icon centers */}
					<div
						className="absolute left-[14px] top-[15px] w-[1.5px]"
						style={{ height: 'calc(100% - 20px)' }}
					>
						{/* Purple portion (completed) - dynamic height based on step */}
						<div
							className="absolute top-0 left-0 w-[2px] bg-brand"
							style={{ height: progressHeight }}
						></div>
						{/* White portion (remaining) - only show if not step 3 */}
						{stepNum !== 3 && (
							<div
								className="absolute left-0 w-full bg-[var(--setup-track,#fff)]"
								style={{
									top: progressHeight,
									height: `calc(100% - ${progressHeight})`
								}}
							></div>
						)}
					</div>

					{/* Step 01: Set up detection */}
					<div className="relative flex items-center gap-[24px] pb-[45px]">
						<div className="relative flex-shrink-0 w-[30px] h-[30px]">
							{isStep1Completed ? (
								/* Completed: Yellow background with checkmark */
								<div className="w-[30px] h-[30px] rounded-[8px] bg-b-yellow-tint border-2 border-[var(--border-brand,#554bfd)] flex items-center justify-center">
									<svg
										className="w-4 h-4 text-t-email-blue"
										fill="none"
										stroke="currentColor"
										viewBox="0 0 24 24"
									>
										<path
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth={3}
											d="M5 13l4 4L19 7"
										/>
									</svg>
								</div>
							) : (
								/* Active: Purple gradient with home icon */
								<div
									className="w-[30px] h-[30px] rounded-[8px] border-2 border-[var(--border-brand,#554bfd)] flex items-center justify-center"
									style={{
										backgroundImage:
											'linear-gradient(-86.7546542701692deg, rgba(145, 138, 255, 1) 3.8923%, rgba(94, 84, 253, 1) 93.118%)'
									}}
								>
									<svg
										width="16"
										height="16"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g clipPath="url(#clip0_4734_43385)">
											<path
												d="M7.33301 7.33333H4.13301C3.38627 7.33333 3.0129 7.33333 2.72769 7.47866C2.4768 7.60649 2.27283 7.81046 2.145 8.06135C1.99967 8.34656 1.99967 8.71993 1.99967 9.46667V14M13.9997 14V4.13333C13.9997 3.3866 13.9997 3.01323 13.8543 2.72801C13.7265 2.47713 13.5225 2.27316 13.2717 2.14532C12.9864 2 12.6131 2 11.8663 2H9.46634C8.7196 2 8.34624 2 8.06102 2.14532C7.81014 2.27316 7.60616 2.47713 7.47833 2.72801C7.33301 3.01323 7.33301 3.3866 7.33301 4.13333V14M14.6663 14H1.33301M9.66634 4.66667H11.6663M9.66634 7.33333H11.6663M9.66634 10H11.6663"
												stroke="white"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</g>
										<defs>
											<clipPath id="clip0_4734_43385">
												<rect width="16" height="16" fill="white" />
											</clipPath>
										</defs>
									</svg>
								</div>
							)}
						</div>
						<div className="flex flex-col gap-[4px]">
							<p className="text-t-email-blue text-[12px] leading-[12px] font-bold">
								Step 01
							</p>
							<p
								className={`text-t-default text-[14px] leading-[16px] opacity-[0.85] ${
									isStep1Completed ? 'line-through' : ''
								}`}
							>
								Set up <span className="font-bold">detection</span>
							</p>
						</div>
					</div>

					{/* Step 02: Connect your Ad account */}
					<div className="relative flex items-center gap-[24px] pb-[45px]">
						<div className="relative flex-shrink-0 w-[30px] h-[30px]">
							{isStep2Completed ? (
								/* Completed: Yellow background with checkmark */
								<div className="w-[30px] h-[30px] rounded-[8px] bg-b-yellow-tint border-2 border-[var(--border-brand,#554bfd)] flex items-center justify-center">
									<svg
										className="w-4 h-4 text-t-email-blue"
										fill="none"
										stroke="currentColor"
										viewBox="0 0 24 24"
									>
										<path
											strokeLinecap="round"
											strokeLinejoin="round"
											strokeWidth={3}
											d="M5 13l4 4L19 7"
										/>
									</svg>
								</div>
							) : isStep2Active ? (
								/* Active: Purple gradient with link icon */
								<div
									className="w-[30px] h-[30px] rounded-[8px] border-2 border-[var(--border-brand,#554bfd)] flex items-center justify-center"
									style={{
										backgroundImage:
											'linear-gradient(-86.7546542701692deg, rgba(145, 138, 255, 1) 3.8923%, rgba(94, 84, 253, 1) 93.118%)'
									}}
								>
									<svg
										width="16"
										height="16"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g clipPath="url(#clip0_4734_43899)">
											<path
												d="M5.00016 4.6665H4.66683C2.82588 4.6665 1.3335 6.15889 1.3335 7.99984C1.3335 9.84079 2.82588 11.3332 4.66683 11.3332H6.00016C7.84111 11.3332 9.3335 9.84079 9.3335 7.99984M11.0002 11.3332H11.3335C13.1744 11.3332 14.6668 9.84079 14.6668 7.99984C14.6668 6.15889 13.1744 4.6665 11.3335 4.6665H10.0002C8.15921 4.6665 6.66683 6.15889 6.66683 7.99984"
												stroke="white"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</g>
										<defs>
											<clipPath id="clip0_4734_43899">
												<rect width="16" height="16" fill="white" />
											</clipPath>
										</defs>
									</svg>
								</div>
							) : (
								/* Inactive: White square with purple border and link icon */
								<div className="w-[30px] h-[30px] rounded-[8px] bg-t-step-inactive border border-t-badge-border flex items-center justify-center">
									<svg
										width="16"
										height="16"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g clipPath="url(#clip0_4734_43397)">
											<path
												d="M4.99967 4.6665H4.66634C2.82539 4.6665 1.33301 6.15889 1.33301 7.99984C1.33301 9.84079 2.82539 11.3332 4.66634 11.3332H5.99967C7.84062 11.3332 9.33301 9.84079 9.33301 7.99984M10.9997 11.3332H11.333C13.174 11.3332 14.6663 9.84079 14.6663 7.99984C14.6663 6.15889 13.174 4.6665 11.333 4.6665H9.99967C8.15873 4.6665 6.66634 6.15889 6.66634 7.99984"
												style={{ stroke: 'var(--t-email-blue)' }}
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</g>
										<defs>
											<clipPath id="clip0_4734_43397">
												<rect width="16" height="16" fill="white" />
											</clipPath>
										</defs>
									</svg>
								</div>
							)}
						</div>
						<div className="flex flex-col gap-[4px]">
							<p className="text-t-email-blue text-[12px] leading-[12px] font-bold">
								Step 02
							</p>
							<p
								className={`text-t-default text-[14px] leading-[16px] opacity-[0.85] ${
									isStep2Completed ? 'line-through' : ''
								}`}
							>
								Connect your <span className="font-bold">ad account</span>
							</p>
						</div>
					</div>

					{/* Step 03: Install your Tracking code */}
					<div className="relative flex items-center gap-[24px]">
						<div className="relative flex-shrink-0 w-[30px] h-[30px]">
							{isStep3Active ? (
								/* Active: Purple gradient with route icon */
								<div
									className="w-[30px] h-[30px] rounded-[8px] border-2 border-[var(--border-brand,#554bfd)] flex items-center justify-center"
									style={{
										backgroundImage:
											'linear-gradient(-86.7546542701692deg, rgba(145, 138, 255, 1) 3.8923%, rgba(94, 84, 253, 1) 93.118%)'
									}}
								>
									<svg
										width="16"
										height="16"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g clipPath="url(#clip0_4734_46803)">
											<path
												d="M7.66683 3.3335H7.95643C9.98792 3.3335 11.0037 3.3335 11.3893 3.69836C11.7226 4.01374 11.8703 4.47835 11.7803 4.9283C11.6762 5.44884 10.8469 6.0354 9.18835 7.20852L6.47864 9.12514C4.8201 10.2983 3.99082 10.8848 3.88672 11.4054C3.79673 11.8553 3.94444 12.3199 4.27774 12.6353C4.66332 13.0002 5.67907 13.0002 7.71056 13.0002H8.3335M5.3335 3.3335C5.3335 4.43807 4.43807 5.3335 3.3335 5.3335C2.22893 5.3335 1.3335 4.43807 1.3335 3.3335C1.3335 2.22893 2.22893 1.3335 3.3335 1.3335C4.43807 1.3335 5.3335 2.22893 5.3335 3.3335ZM14.6668 12.6668C14.6668 13.7714 13.7714 14.6668 12.6668 14.6668C11.5623 14.6668 10.6668 13.7714 10.6668 12.6668C10.6668 11.5623 11.5623 10.6668 12.6668 10.6668C13.7714 10.6668 14.6668 11.5623 14.6668 12.6668Z"
												stroke="white"
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</g>
										<defs>
											<clipPath id="clip0_4734_46803">
												<rect width="16" height="16" fill="white" />
											</clipPath>
										</defs>
									</svg>
								</div>
							) : (
								/* Inactive: White square with purple border and route icon */
								<div className="w-[30px] h-[30px] rounded-[8px] bg-t-step-inactive border border-t-badge-border flex items-center justify-center">
									<svg
										width="16"
										height="16"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<g clipPath="url(#clip0_4734_43823)">
											<path
												d="M7.66683 3.3335H7.95643C9.98792 3.3335 11.0037 3.3335 11.3893 3.69836C11.7226 4.01374 11.8703 4.47835 11.7803 4.9283C11.6762 5.44884 10.8469 6.0354 9.18835 7.20852L6.47864 9.12514C4.8201 10.2983 3.99082 10.8848 3.88672 11.4054C3.79673 11.8553 3.94444 12.3199 4.27774 12.6353C4.66332 13.0002 5.67907 13.0002 7.71056 13.0002H8.3335M5.3335 3.3335C5.3335 4.43807 4.43807 5.3335 3.3335 5.3335C2.22893 5.3335 1.3335 4.43807 1.3335 3.3335C1.3335 2.22893 2.22893 1.3335 3.3335 1.3335C4.43807 1.3335 5.3335 2.22893 5.3335 3.3335ZM14.6668 12.6668C14.6668 13.7714 13.7714 14.6668 12.6668 14.6668C11.5623 14.6668 10.6668 13.7714 10.6668 12.6668C10.6668 11.5623 11.5623 10.6668 12.6668 10.6668C13.7714 10.6668 14.6668 11.5623 14.6668 12.6668Z"
												style={{ stroke: 'var(--t-email-blue)' }}
												strokeWidth="1.5"
												strokeLinecap="round"
												strokeLinejoin="round"
											/>
										</g>
										<defs>
											<clipPath id="clip0_4734_43823">
												<rect width="16" height="16" fill="white" />
											</clipPath>
										</defs>
									</svg>
								</div>
							)}
						</div>
						<div className="flex flex-col gap-[4px]">
							<p className="text-t-email-blue text-[12px] leading-[12px] font-bold">
								Step 03
							</p>
							<p className="text-t-default text-[14px] leading-[16px] opacity-85">
								Install your <span className="font-bold">tracking code</span>
							</p>
						</div>
					</div>
				</div>
				<div className="h-px w-full bg-[var(--setup-divider,rgba(17,21,83,0.15))] lg:my-[24px] my-[12px]" />

				{/* Help Section */}
				<div className="rounded-[12px] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] overflow-hidden lg:block hidden">
					<div className="flex flex-col gap-[16px]">
						{/* Video thumbnail */}
						{videoThumbnail && videoUrl && videoTitle && (
							<button
								onClick={() => {
									const stepName =
										stepNum === 1
											? 'protect_website'
											: stepNum === 2
											? 'ad_account'
											: 'tracking_code'
									trackPostHogEvent(
										PostHogEvent.ONBOARDING_WATCH_TUTORIAL,
										PostHogPath.ONBOARDING,
										{ step: stepName }
									)
									setShowVideoDialog(true)
								}}
								className="relative h-[124px] w-full rounded-[16px] overflow-hidden cursor-pointer mx-[12px]"
								style={{ width: 'calc(100% - 24px)' }}
							>
								<div className="absolute inset-0 blur-[5px] border border-t-card-border opacity-50 rounded-[16px] overflow-hidden">
									<video
										className="w-full h-full object-cover"
										poster={videoThumbnail}
										muted
									>
										<source src={videoUrl} type="video/mp4" />
									</video>
								</div>
								<div className="absolute inset-0 border-2 border-hairline-faint-2 rounded-[16px] pointer-events-none"></div>
								<div className="absolute inset-0 flex items-center justify-center p-6">
									<div className="flex flex-col gap-[9px] items-center relative z-10">
										<div className="relative w-[47px] h-[47px] rounded-full">
											<div className="absolute inset-0 bg-white/80 rounded-full"></div>
											<div className="absolute inset-0 backdrop-blur-[2.5px] rounded-full overflow-hidden">
												<div className="absolute inset-0 bg-white opacity-60"></div>
											</div>
											<div className="absolute inset-0 flex items-center justify-center">
												<img
													src={PlayButtonIcon}
													alt="Play"
													className="w-5 h-5 ml-0.5"
												/>
											</div>
										</div>
										<p className="text-t-default text-[14px] leading-[22px] text-center">
											{videoTitle}
										</p>
									</div>
								</div>
							</button>
						)}

						{/* Knowledge base button */}
						<button
							onClick={() => {
								const stepName =
									stepNum === 1
										? 'protect_website'
										: stepNum === 2
										? 'ad_account'
										: 'tracking_code'
								trackPostHogEvent(
									PostHogEvent.ONBOARDING_KNOWLEDGE_BASE,
									PostHogPath.ONBOARDING,
									{ step: stepName }
								)
								window.open(knowledgeBaseUrl, '_blank')
							}}
							className="flex items-center gap-[4px] text-t-default hover:bg-[var(--setup-help-hover,#fff)] transition-colors rounded-full py-[8px] px-[12px] text-[14px] leading-[15px] font-normal w-full"
						>
							<BookOpenIcon />
							<span className="px-[2px] text-t-default">
								Visit our knowledge base
							</span>
						</button>

						{/* Talk to support */}
						<button
							onClick={() => ChatService.open()}
							className="flex items-center gap-[4px] text-t-default hover:bg-[var(--setup-help-hover,#fff)] transition-colors rounded-full py-[8px] px-[12px] text-[14px] leading-[15px] font-normal w-full"
						>
							<ChatIcon />
							<span className="px-[2px] text-t-default">Chat with us</span>
						</button>

						{/* Skip to Dashboard - hidden on Step 1 for first-time websites */}
						{(stepNum > 1 || !isFirstWebsite) && accountId && (
							<button
								onClick={handleSkipToDashboard}
								className="flex items-center gap-[4px] text-[color:var(--text-link,#554bfd)] hover:bg-[var(--setup-help-hover,#fff)] transition-colors rounded-full py-[8px] px-[12px] text-[14px] leading-[15px] font-normal w-full"
							>
								<ShieldIcon />
								<span className="px-[2px]">Skip to Dashboard</span>
							</button>
						)}
					</div>
				</div>
			</div>

			{/* Video Popup Dialog */}
			{!!videoThumbnail && !!videoUrl && !!videoTitle && (
				<GDialog
					open={showVideoDialog}
					onClose={() => setShowVideoDialog(false)}
					maxWidth="3xl"
					title={videoTitle}
				>
					<div className="flex items-center justify-center w-full">
						<video
							className="w-full rounded-lg"
							controls
							autoPlay
							poster={videoThumbnail}
						>
							<source src={videoUrl} type="video/mp4" />
						</video>
					</div>
				</GDialog>
			)}
		</>
	)
}
